import { lname } from '@/i18n/names';

/** Отдельный силуэт и размер оборонительной башни для каждого из десяти уровней. */
const APPEARANCES = [
  ['Дозорный пост', 'Timber lookout', 1.46],
  ['Укреплённый дозор', 'Reinforced watch post', 1.59],
  ['Каменная стражница', 'Stone sentry tower', 1.73],
  ['Круглая караульная', 'Round guard tower', 1.86],
  ['Зубчатая башня', 'Crenellated tower', 2.0],
  ['Восьмигранный оплот', 'Octagonal ward', 2.13],
  ['Парные стражи', 'Twin sentinels', 2.27],
  ['Баллистный бастион', 'Ballista bastion', 2.4],
  ['Королевская дозорная', 'Royal watchtower', 2.54],
  ['Коронная боевая башня', 'Crown battle tower', 2.67],
] as const;

export const TOWER_ART_LEVELS = APPEARANCES.map((_, index) => index + 1);

export function towerArtLevel(level: number | null | undefined): number {
  return Math.min(APPEARANCES.length, Math.max(1, Math.floor(Number.isFinite(level) ? level! : 1)));
}

export function towerArtUrl(level: number | null | undefined): string {
  return `/art/world/towers/tower_${towerArtLevel(level)}.webp?tower-timers-v2`;
}

export function towerArtScale(level: number | null | undefined): number {
  return APPEARANCES[towerArtLevel(level) - 1]![2];
}

export function towerArtName(level: number | null | undefined, _language?: string): string {
  const [ru, en] = APPEARANCES[towerArtLevel(level) - 1]!;
  return lname(ru, en);
}
